import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

const featureimg =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-11.png";

const gal1 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-04.png";
const gal2 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-01.png";
const gal3 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-02.png";
const gal4 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-03.png";

const icon1 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-05.png";
const icon2 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-06.png";
const icon3 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-07.png";
const icon4 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-08.png";
const icon5 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-09.png";
const icon6 =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-10.png";

const warranty =
  "https://eclipsemattress.in/assets/images/products/coil-on-coil/Coil-N-Coil-12.png";

export default function CoilOnCoilPage({ location }) {
  const data = {
    galleryImages: [gal1, gal2, gal3, gal4],
    productName: "COIL ON COIL",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/logos-033.png",
    descriptionTitle:
      "The Best Of Both Worlds: Most Advanced & Superlative Dual Spring Technology.",
    descriptionText:
      "Meet our most advanced mattress yet. Coil on Coil combines our pocketed springs and Bonnell inner springs so that you are offered optimum support and comfort. This Dual-spring technology allows the springs to interact with each other, therefore providing both Firm and Plush comfort levels. Now you never have to settle for just one option ever again.",
    category: { title: "Patent Series", link: "/patent-series-mattress/" },
    warrantyIcons: [
      "https://eclipsemattress.in/assets/features/logo-04.png",
      "https://eclipsemattress.in/assets/features/logo-05.png",
      "https://eclipsemattress.in/assets/features/logo-06.png",
      "https://eclipsemattress.in/assets/features/logo-01.png",
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
      icon6,
    ],
    featuresText: [
      "Eclipse Memory Foam soft quilted top",
      "Soft Cotton Felt",
      "HD Pocket Spring System",
      "Patented Life Edge Perimeter Support",
      "Turkish Cotton Felt",
      "Chiropractic Bonnell Spring",
      "Hard Turkish Cotten Felt",
      "Eclipse Natural Belgium Latex",
    ],

    points: [
      "416 heavy gauge Bonnell Innersprings",
      "941 Pocketed Innersprings",
      "Spinal Zone patented technology for enhanced back support",
      "Patented Life Edge Perimeter Support technology",
      "Allergen-free fabric",
      "Both firm & plush levels in one mattress",
    ],

    featuresImage: featureimg,
    warrantyImage: warranty,
    price: "₹1,37,599 - ₹4,23,499",

    relatedProducts: [
      {
        title: "Tiara Cool",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/tiara-cool.jpg",
        link: "/patent-series-mattress/tiara-cool/",
      },
      {
        title: "Accolade PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/accolade-pt.jpg",
        link: "/patent-series-mattress/accolade-pt/",
      },
      {
        title: "Vienna ET",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/vienna-et.jpg",
        link: "/patent-series-mattress/vienna-et/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Coil on Coil Spring Mattress | Eclipse International"
        description="Buy the most advanced and superlative coil on Coil Spring Mattress at Best Price with 10 years warranty. Combined with pocket spring and Bonnell inner springs"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-coinoncoil.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
